// Lightweight address parser: extracts street, city, state, postalCode when possible.
// This is intentionally conservative: it will not attempt full international parsing.
export function parseAddress(raw) {
  if (!raw || typeof raw !== 'string') return {};
  const s = raw.trim();
  // Common US-style formats: '123 Main St, Springfield, WA 98101' or 'Springfield, WA'
  const parts = s
    .split(',')
    .map(p => p.trim())
    .filter(Boolean);
  const result = { raw: s };

  if (parts.length === 1) {
    // single token: keep as street or city
    result.street = parts[0];
    return result;
  }

  // Check if last part is just a zip code (5 or 9 digits)
  const last = parts[parts.length - 1];
  const zipOnly = last.match(/^(\d{5}(?:-\d{4})?)$/);

  if (zipOnly && parts.length >= 3) {
    // Format: "Street, City, State, Zip" - zip is separate
    result.postalCode = zipOnly[1];
    // Check if second-to-last is a state
    const secondLast = parts[parts.length - 2];
    const stateMatch = secondLast.match(/^([A-Za-z]{2})$/);
    if (stateMatch) {
      result.state = stateMatch[1].toUpperCase();
      // city is third from end
      if (parts.length >= 3) result.city = parts[parts.length - 3];
      // street is everything before city
      if (parts.length >= 4) result.street = parts.slice(0, parts.length - 3).join(', ');
      return result;
    }
  }

  // last part may contain state + zip together
  const stateZipMatch = last.match(/([A-Za-z]{2})\s*(\d{5}(?:-\d{4})?)?/);
  if (stateZipMatch) {
    result.state = stateZipMatch[1].toUpperCase();
    if (stateZipMatch[2]) result.postalCode = stateZipMatch[2];
    // city is the penultimate part
    if (parts.length >= 2) result.city = parts[parts.length - 2];
    // street is everything before city
    if (parts.length >= 3) result.street = parts.slice(0, parts.length - 2).join(', ');
    return result;
  }

  // fallback: assume last part is city or region
  result.city = parts[parts.length - 1];
  result.street = parts.slice(0, parts.length - 1).join(', ');
  return result;
}

export default { parseAddress };
